// Was jedes Häkchen der Tool-Rechte wirklich freischaltet (seit 08.10.2026).
//
// Anlass: "Ich verstehe nicht, welche Berechtigung für welche Funktion ist." Die
// Seite zeigte je Bereich nur "Sehen / Erstellen / Bearbeiten" - was das im Bereich
// heißt, stand nirgends, und manches Häkchen bewirkt gar nichts.
//
// Erhoben aus dem Programmcode: Menü (App.js, VIEW_TOOL_KEYS), Prüfungen am Server
// (api/contracts/usage.js, state.js, settings.js) und in den Seiten. Wer eine
// Prüfung ändert oder ergänzt, passt den Satz hier mit an.
//
// null = das Häkchen hat in diesem Bereich keine eigene Wirkung. Die Rechte-Seite
// zeigt dafür kein Häkchen, sondern "ohne Wirkung". Gespeichert bleibt es trotzdem
// (Erstellen und Bearbeiten schalten Sehen mit ein, siehe withFlagUpdate).

export const RECHTE_TEXTE = {
  contractsAm: {
    ort: 'Verträge → Erstellen, Bearbeiten, Abwägen',
    canView: 'Menüpunkte öffnen und den Vertrag aus dem Deal füllen (Vorschau)',
    canCreate: 'Vertrag in Bitrix hochladen – braucht zusätzlich „Deals & Bulk: Erstellen“',
    canEdit: '„Aus dem Gespräch“ und Abwägen nutzen (KI-Entwürfe, Freigaben)',
    hinweis: 'Ohne „Vorlagen: Sehen“ nimmt Erstellen die Originalvorlage, ohne „Paragraphen: Sehen“ fehlen die optionalen Paragraphen.',
  },
  contractsAmQueue: {
    ort: 'Verträge → Deals, außerdem Angebote → FFPV Flyer',
    canView: 'Deal-Liste, Upload-Aufträge und Downloads sehen, FFPV Flyer ansehen',
    canCreate: 'Verträge per Bulk erstellen, Einzelvertrag hochladen, FFPV Flyer erzeugen',
    canEdit: 'Nur FFPV Flyer: Mapping und Vorlage ändern',
  },
  // Seit 21.10.2026 (api/_lib/dokumentenAssistentWeg.js). Ohne eigenen Eintrag nur Admins:
  // Das Recht hat bewusst keinen Alias.
  dokumentenAssistent: {
    ort: 'Verträge → Bearbeitung → Dokumenten-Assistent',
    canView: 'Seite öffnen und die eigenen Aufträge sehen',
    canCreate: 'Dokumente erkennen, zuschneiden und im Deal ablegen – auch als Probelauf',
    canEdit: null,
    hinweis: 'Ohne eigenen Eintrag nur für Admins sichtbar. Admins sehen die Aufträge aller.',
  },
  contractTemplates: {
    ort: 'Verträge → Vorlagen',
    // Seit 09.10.2026 bekommt jeder, der Verträge füllt oder erstellt, die gespeicherte
    // Vorlage auch ohne dieses Häkchen (api/contracts/state.js, darfVorlageLesen).
    canView: 'Menüpunkt öffnen und Vertragsvorlagen lesen (wer Verträge erstellt, nutzt die gespeicherte Vorlage auch ohne dieses Häkchen)',
    canCreate: null,
    canEdit: 'Vorlagen ändern, zurücksetzen und ältere Fassungen wiederherstellen',
  },
  contractsAmClauses: {
    ort: 'Verträge → Paragraphen',
    canView: 'Paragraphen lesen – auch nötig für „Optionale Paragraphen“ beim Erstellen',
    canCreate: null,
    canEdit: 'Paragraphen anlegen, ändern und löschen',
  },
  contractsAmAutomations: {
    ort: 'Einstellungen → Automatisierung',
    canView: 'Menüpunkt öffnen',
    canCreate: null,
    canEdit: 'Auslöser-Phasen und Adressfelder speichern (An/Aus nur Admins)',
  },
  vermittlervertrag: {
    ort: 'Vermittlervertrag',
    canView: 'Menüpunkt und Vorlage öffnen',
    canCreate: 'Vertrag als HTML oder PDF erzeugen und herunterladen',
    canEdit: 'Knopf „Erzeugen und bearbeitbar öffnen“ – braucht zusätzlich Erstellen',
  },
  ffpvTeaser: {
    ort: 'Angebote → Projektteaser FFPV',
    canView: 'Liste, Vorschau und Verlauf sehen',
    canCreate: 'PDF erzeugen, in den Deal legen, Vorlage speichern',
    canEdit: 'Mapping-Editor anzeigen',
  },
  offers: {
    ort: 'Angebote → Dach PV, Sanierung, Freiflächen PV, Kleinspeicher, Großspeicher',
    canView: 'Angebotsvorlagen ansehen',
    canCreate: 'Exportieren (PDF, DOCX, PNG) und im Generator erzeugen',
    canEdit: 'Layout bearbeiten, speichern und veröffentlichen',
  },
  exposes: {
    ort: 'Exposés → Erstellen, Aus Projekt-Cockpit, Vorlagen',
    canView: 'Exposés laden, Vorschau und PDF',
    canCreate: 'Vorschau füllen, speichern, exportieren, im Generator erzeugen',
    canEdit: 'Mapping speichern und Exposé-Vorlagen bearbeiten',
  },
  flyer: {
    ort: 'Angebote → Flyer',
    canView: 'BESS- und Schwarmspeicher-Flyer ansehen',
    canCreate: 'Exportieren (PDF, PNG)',
    canEdit: 'Inhalte im Editor ändern',
  },
  vertrieb: {
    ort: 'Angebote → Vertriebspräsentation',
    canView: 'Folien ansehen',
    canCreate: 'Exportieren und im Generator erzeugen',
    canEdit: 'Texte auf den Folien ändern',
  },
  generator: {
    ort: 'Angebote → Generator',
    canView: 'Seite öffnen',
    canCreate: 'PDF oder HTML per Deal-ID erzeugen – braucht zusätzlich Erstellen im jeweiligen Bereich',
    canEdit: null,
  },
  designsystem: {
    ort: 'Einstellungen → Design System',
    canView: 'Seite ansehen',
    canCreate: null,
    canEdit: null,
  },
  eegRechner: {
    ort: 'Werkzeuge → EEG-Vergütung',
    canView: 'Rechner nutzen',
    canCreate: null,
    canEdit: null,
  },
  standardDocumentTemplates: {
    ort: 'Standarddokumente → Vorlagen',
    canView: 'Menüpunkt öffnen und Vorlagen lesen (wer Dokumente erstellt, nutzt die gespeicherte Vorlage auch ohne dieses Häkchen)',
    canCreate: null,
    canEdit: 'Vorlagen ändern und ältere Fassungen wiederherstellen',
  },
  standardDocuments: {
    ort: 'Standarddokumente → Erstellen',
    canView: 'Menüpunkt öffnen und Dokument aus dem Deal füllen',
    canCreate: 'Dokument per Mail senden',
    canEdit: null,
  },
  standardDocumentsFax: {
    ort: 'Standarddokumente → Erstellen, Kasten „Faxversand“',
    // Kein null: Erstellen schaltet Sehen mit ein, und ohne Häkchen ließe es sich nicht
    // mehr abnehmen (Review 08.10.2026).
    canView: 'Keine eigene Wirkung – Erstellen schaltet es mit ein',
    canCreate: 'Dokument per Fax senden',
    canEdit: null,
  },
  onboarding: {
    ort: 'On-Boarding → E-Mail Signatur',
    canView: 'Signatur ansehen und kopieren',
    canCreate: 'Signatur als Windows-ZIP herunterladen',
    canEdit: null,
  },
  mittwaldMail: {
    ort: 'On-Boarding → Mittwald Postfach',
    canView: 'Deals der Phase „IT einrichten“ ansehen',
    canCreate: 'Postfach-Zugangsdaten in Bitrix eintragen',
    canEdit: null,
  },
  bitrixUser: {
    ort: 'On-Boarding → Bitrix Zugang',
    canView: 'Deals, Abteilungen und Phasen ansehen',
    canCreate: 'Bitrix-Nutzer anlegen',
    canEdit: null,
  },
};

/** Satz zu einem Häkchen; null, wenn es im Bereich keine Wirkung hat. */
export function rechtText(toolKey, flagKey) {
  const texte = RECHTE_TEXTE[toolKey];
  if (!texte) return '';
  return texte[flagKey];
}

/** Hat das Häkchen im Bereich eine Wirkung? Unbekannte Bereiche: ja (lieber zeigen). */
export function rechtWirkt(toolKey, flagKey) {
  return rechtText(toolKey, flagKey) !== null;
}
